import { render, staticRenderFns } from "./EditModelDialog.vue?vue&type=template&id=649c6a19&"
import script from "./EditModelDialog.vue?vue&type=script&lang=js&"
export * from "./EditModelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports